import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import DownloadMaterialButton from '../DownloadMaterialButton';

import { minDesktop } from '../styles/breakpoints';

import H2 from '../H2';

const DESCRIPTIONS = [
  'Hinweise zur Nutzung',
  'Einf&uuml;hrung in das Thema',
  'Acht Lerneinheiten',
  'Hintergrundinformationen',
  'Unterrichtsimpulse',
  'Arbeitsbl&auml;tter',
];

const UL = styled.ul`
  padding: 0;
  padding-bottom: 5px;
`;

const LI = styled.li`
  font-size: 16px;
  line-height: 1.2;
  list-style-type: none;

  &:before {
    content: '\u2192';
    font-family: 'PT Mono', monospace;
    margin-right: 0.5em;
    margin-left: 0.1em;

    font-size: 24px;
    ${minDesktop} {
      font-size: 32px;
    }
  }

  ${minDesktop} {
    font-size: 22px;
  }
`;

const Article = styled.article`
  margin-top: 20px;
  padding-bottom: 50px;
`;

const DownloadContainer = styled.div``;

const DownloadMaterialButtonStyled = styled(DownloadMaterialButton)`
  padding: 15px 20px;
  border-radius: 3px;
`;

const MaterialDescription = ({ className }) => (
  <Article className={className}>
    <H2>
      Unterrichtsmaterialien f&uuml;r die Grundschule, <nobr>3.–6. Klasse</nobr> (PDF)
    </H2>
    <UL>
      { DESCRIPTIONS.map(text => (
        <LI key={text} dangerouslySetInnerHTML={{ __html: text }} />
      ))}
    </UL>
    <DownloadContainer>
      <DownloadMaterialButtonStyled label="Lehrplananbindung" download="Lehrplananbindung.pdf" href="/downloads/Lehrplananbindung.pdf" />
    </DownloadContainer>
  </Article>
);

MaterialDescription.propTypes = {
  className: PropTypes.string,
};

MaterialDescription.defaultProps = {
  className: undefined,
};

export default MaterialDescription;



// WEBPACK FOOTER //
// ./src/components/AboutMaterialDownload/MaterialDescription.js